import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { updatePageConfig } from '../../../services/queries/MaggieViewQueries';
import { pageConfigPFJ } from '../state/PageStateJ';

export function useReorderViews() {
  const setPageConfig = useSetAtom(pageConfigPFJ);

  return useCallback(
    async (newOrder: string[]) => {
      const newPageConfig = await updatePageConfig({ order: newOrder });

      setPageConfig(newPageConfig);
    },
    [setPageConfig]
  );
}
